<!-- 全景图 -->
<template>
<div class="layout">
    <div class="bg">
        <iframe src="./vtour/tour.html" frameborder="0"></iframe>
    </div>
   <div class="title"><img src="../../assets/img/title.png" alt=""></div>
   <div class="button" @click="enterPano()"><img src="../../assets/img/button.png" alt=""></div>
  
   
</div>

</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
export default {
//import引入的组件需要注入到对象中才能使用

components: {
   
},
data() {
//这里存放数据
return {
    
};

},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {
    
},
//方法集合
methods: {
   
    enterPano() {
        this.$router.push('/panorama');
    }
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {
    
    
},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {
},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类

.layout {
    width:100%;
    height:100%;
    .bg {
        position:relative;
        width:100%;
        height:100%;
        iframe {
            width:100%;
            height:100%;
        }
    }
    .title {
        position:absolute;
        width:45.1vw;
        top:8vw;
        left:0;
        right:0;
        margin:auto;
    }
    .button {
        position:absolute;
        width:14vw;
        bottom:4vw;
        left:0;
        right:0;
        margin:auto;
    }
    
}
@media screen and (max-width:600px) {
  .layout {
    .title {
        width:68%;
        top:5vh;
    }
    .button {
      position: absolute;
      width: 40vw;
      bottom: 10vh;
      left: 0;
      right: 0;
      margin: auto;
    }
  }
  
}
</style>